import { ACC_CONFIG, ACC_MODULES } from "./index";
import log from "../../utils/logger/library";
import importMF from "../importMF";

/**
 * Initializes the account centre public path. The public path is used to
 * fetch federated modules from the account centre.
 *
 * @returns {Promise}
 */
export const initAccountCentreMF = async () => {
    try {
        const setPublicPath = await importMF(ACC_MODULES.setPublicPath);
        const accPublicPath = `${ACC_CONFIG.publicPath}/`;

        setPublicPath(accPublicPath); // Set Membership's public path
    } catch (error) {
        log.error(
            `Failed to initialize account centre's public path [${error.message}]`
        );
    }
};
